function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.89 0H10.7a1.11 1.11 0 00-1.109 1.11c0 .611.498 1.109 1.11 1.109h3.51L8.356 8.075c-.21.21-.325.488-.325.785 0 .296.116.575.325.784.21.21.488.325.785.325.296 0 .575-.115.784-.325l5.857-5.856v3.51a1.11 1.11 0 002.219 0V1.11A1.11 1.11 0 0016.89 0z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.752 16.098H1.902V5.248h8.16l1.902-1.901H.95a.951.951 0 00-.951.95V17.05c0 .526.426.951.951.951h12.752a.95.95 0 00.95-.95V6.035l-1.901 1.902v8.16z",
  fill: "#fff"
});

function SvgIconExtermalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconExtermalLink;